import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import {ADTF_SUB_COMPONENT_ROUTES} from "../../util/RouteConstants";
import SelectLayout, {NavigationRoutes} from "../../util/SelectLayout";

class AdtfSubComponentSelectPage extends Component {
    render() {
        return (
            <Column>
                <SelectLayout routes={ADTF_SUB_COMPONENT_ROUTES.sort((a,b) => {
                    return a.name.localeCompare(b.name);
                })} location={this.props.location} history={this.props.history} isComponentTypeSelect={"true"}/>
                <NavigationRoutes routes={ADTF_SUB_COMPONENT_ROUTES}/>
            </Column>
        )
    }
}

export default AdtfSubComponentSelectPage


// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/AdtfSubComponentSelectPage.js